// 平台医院科室租户 guid（科室统一口径：mf_med_dept 配置表业务——科室管理页维护的平台租户树，
// 非字典；与小程序 medDeptChoose.getPlatformGuid、平台"超级运营公司"惯例同款环境分支）
// 测试/本地=武汉链享供应链科技有限公司；uat/pre/生产=武汉链享医药供应链管理有限公司
export function getPlatformDeptTenantGuid() {
  const href = location.href;
  const isProdLike = href.indexOf('//scm-operation-pre-test.cs4pl.com') > -1
    || href.indexOf('https://scm-operation.csyaoly.com') > -1
    || href.indexOf('https://scm-operation.cs4pl.com') > -1;
  return isProdLike ? '89a3261c262411ebad37fa163e4b37cf' : '1aaf025422ff11eb9405080027ac9e40';
}
